import { mergeWith } from 'lodash';
import { lang } from './element';
import * as scssVariables from './plugins/variables/constants';

// elementui 语言包
const elementLocaleMessage = {
  'zh-CN': lang.zhCN,
  'en-US': lang.en
};

let xpcConfig = {
  // XPC组件前缀
  componentPrefix: 'Rt',

  // 省市县请求地址
  address: {
    provinceUrl: '',
    cityUrl: '',
    countyUrl: '',
    alias: { id: 'Id', name: 'Name' },
    autoLoad: true
  },

  // 默认语言
  defaultLocale: 'zh-CN',
  // 默认语言的localStorage key
  defaultLocaleStorageKey: 'i18nLocale',

  // 默认语言id
  defaultLocaleId: '2052',
  // 默认语言id的localStorage key
  defaultLocaleIdStorageKey: 'i18nLocaleid',

  defaultAppKey: '',
  localesUrl: 'api/PortalLanguage/GetLanguageList',
  localesMessageUrl: 'api/PortalLanguage/GetLanguageConfigs?langId=',
  localeGroup: 'default',
  elementLocaleMessage,

  defaultIconName: 'rt-base-defaultIcon',

  // 状态轴
  stateline: {
    border: true,
    dotColor: 'primary',
    dotSize: 12
  },
  form: {
    labelPosition: 'top', // 表单 label 位置
    inputNeedTips: false
  },
  // 设置清空按钮
  clearicon: {
    clearIconName: 'rt-base-close_fill',
    clearIconRight: 0
  },
  header: {
    sticky: true,
    stickyTop: 0
  },

  dialog: {
    size: {
      height: {
        large: '60%',
        normal: '50%',
        small: '30%'
      }
    }
  },

  // 控制elemment-ui的show-message属性，设置是否显示校验错误信息
  // formItemIsShowMessage: true,
  // 文字提示
  toolTip: {
    opacity: 1,
    size: 'large',
    maxWidth: 400
  },
  // 设置全局RtNode节点配置
  node: {
    small: false, // 节点尺寸大小设置为true使用组件配置的small设置为false为使用全局配置
    showIcon: true, // 是否显示icon设置显示false隐藏
    paddingSize: 'medium' // 可配置large-medium
  },
  // 加载组件全局配置
  loading: {
    size: 'large', // 加载内容大小，默认为large,可选small,medium
    type: 1 // 加载类型，默认为1即3个点，可选2，即圆圈加载
  },
  badge: {
    // 支持显示描边
    isStroke: false
  },
  search: {
    // 搜索框模式，可选值 border（线框，默认）/line（线条）/深色（dark）
    type: 'border'
  },
  // scss文件的变量js对象
  scssVariables: scssVariables,

  // 空状态的 placeholder
  emptyPlaceholder: '--',
  /**
   * XPC提供的可选插件内容，当前包括
   *
   * errorHandler -- 添加全局错误处理方法
   * boundaryAccess -- 添加边界访问控制方法
   */
  plugins: {},

  /**
   * XPC需要被覆盖的内容，
   *
   * 目前暂时只提供针对组件的覆盖过程
   */
  overrides: {
    components: []
  }
};

export default {
  /**
   * @public 读取全局记录中的属性值
   *
   * @param {*} attrPath 属性名，允许用.进行属性合并，如 header.sticky、overrides.components等
   * @returns
   */
  get: attrPath => {
    if (typeof attrPath === 'string') {
      const arr = attrPath.split('.');
      return arr.reduce(
        (res, key) =>
          typeof res === 'object' && res.hasOwnProperty(key)
            ? res[key]
            : undefined,
        xpcConfig
      );
    }

    return xpcConfig;
  },

  /**
   * @public 设置config中的属性值
   *
   * @param {*} key
   * @param {*} value
   */
  set: (key, value) => {
    xpcConfig[key] = value;
  },

  /**
   * @public 批量合并属性
   *
   * @param {*} mergeConfig
   * @returns
   */
  assign: mergeConfig => {
    mergeWith(xpcConfig, mergeConfig, (objValue, srcValue, key) => {
      if (key === 'elementLocaleMessage') {
        return srcValue;
      }
      if (key === 'address') {
        return srcValue;
      }
    });

    if (!mergeConfig.defaultLocale) {
      xpcConfig.defaultLocale =
        localStorage[xpcConfig.defaultLocaleStorageKey] ||
        xpcConfig.defaultLocale;
    }

    if (!mergeConfig.defaultLocaleId) {
      xpcConfig.defaultLocaleId =
        localStorage[xpcConfig.defaultLocaleIdStorageKey] ||
        xpcConfig.defaultLocaleId;
    }

    return xpcConfig;
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/config.js